module.exports = __webpack_public_path__ + "img/124.bd19d893.jpg";